'use strict';
'use es6';

// These should be removed once we have 100% adoption of UIApplication

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

require('../listeners/focusStylesListener');

var _setupStyledComponents = require('../listeners/setupStyledComponents');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _Functions = require('../core/Functions');

var _ShareButton = require('../decorators/ShareButton');

var _ShareButton2 = _interopRequireDefault(_ShareButton);

var _refObject = require('../utils/propTypes/refObject');

var _refObject2 = _interopRequireDefault(_refObject);

var _TabIndex = require('../utils/TabIndex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

(0, _setupStyledComponents.setupStyledComponents)();

var UIClickable = _react2.default.createClass({
  displayName: 'UIClickable',

  propTypes: {
    autoFocus: _react.PropTypes.bool,
    buttonRef: _refObject2.default,
    className: _react.PropTypes.string,
    disabled: _react.PropTypes.bool,
    tagName: _react.PropTypes.string.isRequired,
    onClick: _react.PropTypes.func,
    onKeyDown: _react.PropTypes.func,
    role: _react.PropTypes.string,
    tabIndex: _react.PropTypes.number
  },

  getDefaultProps: function getDefaultProps() {
    return {
      role: 'button',
      tagName: 'div'
    };
  },
  componentDidMount: function componentDidMount() {
    var _props = this.props,
        autoFocus = _props.autoFocus,
        buttonRef = _props.buttonRef;

    if (autoFocus) {
      if (buttonRef.current) buttonRef.current.focus();
    }
  },
  handleKeyDown: function handleKeyDown(evt) {
    var key = evt.key;
    var _props2 = this.props,
        onClick = _props2.onClick,
        onKeyDown = _props2.onKeyDown;


    (0, _Functions.callIfPossible)(onKeyDown, evt);

    // Simulate click on Enter/Spacebar, to emulate button behavior
    if (key === 'Enter' || key === ' ') {
      (0, _Functions.callIfPossible)(onClick, evt);
      if (key === ' ') {
        evt.preventDefault(); // Prevent page from scrolling (#3575)
      }
    }
  },
  handleClick: function handleClick(evt) {
    var _props3 = this.props,
        disabled = _props3.disabled,
        onClick = _props3.onClick;


    if (disabled) {
      evt.preventDefault();
      evt.stopPropagation();
      return;
    }

    (0, _Functions.callIfPossible)(onClick, evt);
  },
  render: function render() {
    var _props4 = this.props,
        buttonRef = _props4.buttonRef,
        className = _props4.className,
        disabled = _props4.disabled,
        __onClick = _props4.onClick,
        __onKeyDown = _props4.onKeyDown,
        role = _props4.role,
        tabIndex = _props4.tabIndex,
        Tag = _props4.tagName,
        rest = _objectWithoutProperties(_props4, ['buttonRef', 'className', 'disabled', 'onClick', 'onKeyDown', 'role', 'tabIndex', 'tagName']);

    return _react2.default.createElement(Tag, _extends({}, rest, {
      'aria-disabled': disabled,
      className: (0, _reactUtils.classNames)('private-clickable', className),
      onClick: this.handleClick,
      onKeyDown: this.handleKeyDown,
      ref: (0, _Functions.wrapRefObject)(buttonRef),
      role: role,
      tabIndex: (0, _TabIndex.getTabIndex)(disabled, tabIndex, null)
    }));
  }
});

exports.default = (0, _ShareButton2.default)(UIClickable);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/button/UIClickable.js
// module id = 55
// module chunks = 0